import React from "react";
import style from '../pricing.module.scss';
import Dropdown from "../../../Components/Dropdown/RealTimeButtonDropDown/DropDown";

const PricingFilters = (props) => {

    return (
        <React.Fragment>
            <div className={style.dropdownRow}>
                {props.checkUrl() ? <div className={style.deleteAll} onClick={() => { props.handleDeleteAll() }}>
                    <span className={style.icon}>g</span></div> : null
                }
                {props.FilterArrays.map((item, index) => {
                    if (item.tag != 'promotion' && props.filterData[`${[item.tag]}s`].length > 1) return <div className={style.dropdownWrapper}
                        key={index}>
                        <Dropdown
                            tag={item.tag}
                            label={item.name}
                            placeHolder={item.name}
                            dropdownList={props.searcher(props.filterData[`${[item.tag]}s`])}
                            hasSearchBox={item.tag == 'brand' || item.tag == 'productGroup' ? true : false}
                            hasCheckbox={true}
                            handleSearch={props.handleDropdownSearch}
                            deleteSelectedItems={() => props.deleteFromUrl(item.tag)}
                            handleSelect={props.selectHandler}
                            action={flag => {
                            }}
                        />
                    </div>
                    if (item.tag == 'promotion') return <div key={index} className={style.dropdownWrapper}>
                        <Dropdown
                            tag='promotion'
                            label='تخفیف هوشمند'
                            placeHolder='تخفیف هوشمند'
                            dropdownList={
                                [{ name: "بدون تغییر قیمت", checked: props.getFromUrl('withoutchangeprice') },
                                { name: "فعال‌سازی ربات در تخفیف هوشمند", checked: props.getFromUrl('activerobotinpromotions') }]
                            }
                            hasSearchBox={false}
                            hasCheckbox={false}
                            hasToggle={true}
                            handleSearch={() => {
                            }}
                            deleteSelectedItems={() => {
                                props.deleteFromUrl('withoutchangeprice');
                                props.deleteFromUrl('activerobotinpromotions')
                            }}
                            handleSelect={props.handleSelect}
                            action={flag => {
                            }}
                        />
                    </div>
                })}
            </div>
        </React.Fragment>
    )
}
export default PricingFilters

